import { render, staticRenderFns } from "./FrameData.vue?vue&type=template&id=dafc94d4"
import script from "./FrameData.vue?vue&type=script&lang=js"
export * from "./FrameData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports